import React from "react";
import Hero from "../components/Hero";
import ProblemSection from "../components/ProblemSection";
import MorningBriefDemo from "../components/MorningBriefDemo";
import HowItWorks from "../components/HowItWorks";
import LegalFirewall from "../components/LegalFirewall";
import DesignPartnerQuote from "../components/DesignPartnerQuote";
import WorkflowsGrid from "../components/WorkflowsGrid";
import Pricing from "../components/Pricing";
import FoundingCustomerSection from "../components/FoundingCustomerSection";
import FAQSection from "../components/FAQSection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ProblemSection />
      <MorningBriefDemo />
      <HowItWorks />
      <LegalFirewall />
      <DesignPartnerQuote />
      <WorkflowsGrid />
      <Pricing />
      <FoundingCustomerSection />
      <FAQSection />
    </main>
  );
}
